  import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalService } from '../global/global.service';
const headers = new HttpHeaders()
    .set("Auth-Key", "ba989509ad560f3ee2427ed27fa86a5d")
    .set("Client-Service", "univate-training");
@Injectable({
  providedIn: 'root'
})
export class StaffSurveyService {
  private url = GlobalService.serverURL + 'company/staff_survey/';

  constructor(
      private http: HttpClient
  ) { }

  list  (data) {
      return this.http.post(this.url + 'listing',data,{ headers })
  }

  view(id){
      return this.http.get(this.url + 'details?su_i=' + id, { headers })
  }

  add (data) {
      return this.http.post(this.url + 'create', data, { headers })
  }

  edit = (data): any => {
      return this.http.post(this.url + 'edit', data, { headers });
  }

  delete (id) {
      return this.http.get(this.url + 'delete?su_i=' + id, { headers })
  }

  // viewSurvey = (id): any => {
  //     return this.http.get(this.url + 'view_survey?survey_id=' + id, { headers }).toPromise();
  // }

  // viewSurveyAnswer = (data): any => {
  //     return this.http.get(this.url + 'view_survey_answer?survey_id=' + data.id + '&portal_id=' + data.portal_id, { headers }).toPromise();
  // }

  getStaffData  () {
      return this.http.get(this.url + 'get_staff_data', { headers })
  }
  assignSurvey(data){
    return this.http.post(this.url + 'survay_assign', data, { headers })
  }
  overallStats(id:string){
    return this.http.get(this.url + 'survey_details?su_i=' + id, { headers })
  }
  employeeListSurvey(data){
    return this.http.post(this.url + 'static_view_survey',data, { headers })
  }
  employeeWiseStats(surveyId:string,empId:string){
    return this.http.get(this.url + 'static_view_survey_ans?su_i='+ surveyId +'&portal_id='+ empId, { headers })
  }
}
